<template>
    <div class="p-5 sm:p-6 pb-0 sm:pb-0" v-if="showBanner && banner.show">
        <NotificationInfo
            class="cursor-pointer"
            @click="callBannerAction(banner.action)"
            @close="closeBanner"
        >
            {{ banner.name }}
        </NotificationInfo>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { NotificationInfo } from "@easy/ui/notifications";
import { localStorageService, STORAGE_KEY } from "@/shared/connection/local-storage.service";
import { loginService } from "@/auth/service/login.service";

export default {
    name: "cAccessBanner",
    components: {
        NotificationInfo,
    },
    data() {
        return {
            showBanner: false,
            closing: false,
            paidPlansDate: new Date("2023-10-16T23:59:59"),
        };
    },
    watch: {
        access: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.showBanner = !localStorageService.readValue(STORAGE_KEY.closeBanner);
                }
            },
        },
    },
    computed: {
        ...mapState(["activeApp", "user", "lang"]),
        ...mapGetters(["logged", "easyUrls"]),
        beforePaidPlans() {
            const now = new Date();
            return now < this.paidPlansDate;
        },
        access() {
            return this.user.access;
        },
        accessToActiveApp() {
            return this.access && this.activeApp ? this.access[this.activeApp] : "";
        },
        accessToAllApps() {
            return this.access["all"];
        },
        projectsNumber() {
            return this.compareProjectsLimits(this.accessToActiveApp, this.accessToAllApps);
        },
        unloggedBanner() {
            return {
                show: !this.logged,
                name: this.$l({
                    en: "You can keep working, but you will not be able to keep your progress until you log in with easycart or create a new account.",
                    pl: "Możesz pracować dalej, ale zachowasz postępy dopiero, gdy zalogujesz się przez easycart lub założysz nowe konto.",
                }),
                action: function () {
                    window.location.href = loginService.generateLogInLink(this.lang);
                },
            };
        },
        activeToolBanner() {
            return {
                show: this.logged && this.accessToActiveApp === 0,
                name: this.$l({
                    pl: "W bezpłatnym planie możesz tworzyć dowolną liczbę szkiców, ale bez możliwości ich publikacji",
                    en: "In the free plan you can create any number of sketches, but without the possibility of publicatio",
                }),
                action: () => {
                    this.buyPro();
                },
            };
        },
        allToolBanner() {
            return {
                show:
                    this.logged &&
                    this.accessToActiveApp === "UNLIMITED" &&
                    this.accessToAllApps === 0,
                name: this.$l({
                    pl: "Zaoszczędź 40% i wypróbuj nasze pozostałe narzędzia",
                    en: "Save 40% and try our other tools",
                }),
                action: () => {
                    this.buyPro({ tool: "tools" });
                },
            };
        },
        moreProjectsBanner() {
            return {
                show:
                    this.logged &&
                    this.accessToActiveApp !== 0 &&
                    this.accessToActiveApp &&
                    this.accessToActiveApp !== "UNLIMITED",
                name: this.$l({
                    pl: `Możesz opublikować ${this.accessToActiveApp} ${this.projectsPL(
                        this.accessToActiveApp
                    )}. Potrzebujesz więcej? Kup w pakiecie i zaoszczędź 40%`,
                    en: `You can publish ${this.accessToActiveApp} projects. Need more? Buy in a package and save 40%`,
                }),
                action: () => {
                    this.buyPro();
                },
            };
        },
        banner() {
            if (this.beforePaidPlans) {
                return {
                    show: true,
                    name: this.$l({
                        pl: "zostało do wprowadzenia płatnych planów w easytools, zobacz nasz cennik",
                        en: "left to introduce paid plans in easytools, see our price list",
                    }),
                    action: function () {
                        window.location.href = "https://www.easytools.pl/cennik";
                    },
                };
            }

            if (this.unloggedBanner.show) {
                return this.unloggedBanner;
            } else if (this.activeToolBanner.show) {
                return this.activeToolBanner;
            } else if (this.allToolBanner.show) {
                return this.allToolBanner;
            } else if (this.moreProjectsBanner.show) {
                return this.moreProjectsBanner;
            } else {
                return { show: false };
            }
        },
    },
    methods: {
        ...mapActions(["buyPro"]),
        closeBanner() {
            localStorageService.saveValue(STORAGE_KEY.closeBanner, true);
            this.closing = true;
            setTimeout(() => {
                this.showBanner = false;
            }, 150);
        },
        compareProjectsLimits(value1, value2) {
            if (value1 === "UNLIMITED" || value2 === "UNLIMITED") {
                return "UNLIMITED";
            } else {
                return Math.max(Number(value1), Number(value2));
            }
        },
        projectsPL(number) {
            if (number === 1) return "projekt";
            if (number > 1 && number < 5) return "projekty";
            return "projektów";
        },
        callBannerAction(action) {
            action.bind(this)();
        },
    },
};
</script>
